// extracted by mini-css-extract-plugin
export default {"container":"SwipeButton_container__oTC5N"};